import { Iata } from '@reward-platform/shared-schemas'
import { isClientDeploymentEnv } from '@reward-platform/utils'

const isString = (value: unknown): value is string => typeof value === 'string'

const parseWhitelist = (value: unknown) =>
  isString(value) ? value.split(',').map((domain) => domain.trim()) : []

const WHITELABEL_URL_WHITELISTS: Record<string, string[]> = {
  BA: parseWhitelist(process.env.NEXT_PUBLIC_BA_DOMAIN_WHITELIST),
  EI: parseWhitelist(process.env.NEXT_PUBLIC_EI_DOMAIN_WHITELIST),
  IB: parseWhitelist(process.env.NEXT_PUBLIC_IB_DOMAIN_WHITELIST),
}

export const isAviosThemeWhitelabelAllowed = (host?: string) => {
  const isLowerEnv = isClientDeploymentEnv(['local', 'dev', 'tst'])
  const aviosThemeUrlWhitelist = parseWhitelist(process.env.NEXT_PUBLIC_AVIOS_DOMAIN_WHITELIST)
  return !!(isLowerEnv && host && aviosThemeUrlWhitelist.includes(host))
}

// Leaving BA here temporarily
const WHITELABEL_IATA_CODES: Iata[] = ['BA', 'EI']

// This determines the platform op co, validating the request using whitelisted urls
export const getWhitelabelOpCoForHost = (host?: string) => {
  if (!host) {
    return null
  }

  const maybeIata = WHITELABEL_IATA_CODES.find((iata) => {
    const whitelabelUrlAllowList = WHITELABEL_URL_WHITELISTS[iata]
    return whitelabelUrlAllowList.includes(host)
  })

  return maybeIata ?? null
}

export const isWhitelabelHost = (host?: string) => !!getWhitelabelOpCoForHost(host)
